<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>

import { firebase } from '@/components/utils/firebase'
import { database } from '@shared/database'

export default {
  name: 'App',
  data () {
    return {
      //
    }
  },
  created() {
    // TODO LamDV
    // let uid = null
    // let unsubscribe = null
    // firebase.auth().onAuthStateChanged(user => {
    //   // skip if NO user
    //   if (!user || !user.uid) {
    //     return
    //   }

    //   // skip if uid is NOT changed
    //   if (uid === user.uid) {
    //     return
    //   }

    //   // unsubscribe old-subscription
    //   if (unsubscribe) {
    //     unsubscribe()
    //   }

    //   console.log({ uid: user.uid })
    //   uid = user.uid
    //   unsubscribe = database.onTraineeUpdated(user.uid, trainee => {
    //     if (this.$route.name !== 'payment' && trainee && !trainee.activated) {
    //       setTimeout(() => {
    //         this.$router.push(`/payment`)
    //       }, 1000)
    //     }
    //   })
    // })
  },
}
</script>

<style>
@import "./plugins/meltline.css";

html,
body {
  margin: 0;
  height: 100%;
}
</style>
